import clsx from 'clsx';
import { HTMLProps, PropsWithChildren } from 'react';
import { ITagItem } from '../../types';
import { Tag } from '../tag';
import classes from './tag-list.module.scss';

export type TagListProps<T extends ITagItem = ITagItem> = PropsWithChildren
  & HTMLProps<HTMLDivElement> & {
    /**
     * Indicates whether or not the tags should wrap within their container.
     */
    noWrap?: boolean;

    /**
   * Interface representing tags for feedback.
   */
    tags?: T[];

    /**
   * Handles the click event on a tag.
   */
    onTagClick?: (tag: T) => void;

    /**
   * Custom class names for the tag list.
   */
    classNames?: {
      tag?: string;
    };
  };

export function TagList<T extends ITagItem = ITagItem>({
  children,
  tags,
  noWrap,
  onTagClick,
  classNames,
  ...props
}: TagListProps<T>) {
  if ((tags ?? []).length <= 0 && !children) {
    return null;
  }

  return (
    <div
      {...props}
      role="list"
      className={clsx(classes.root, 'tag-list-component', props.className, { [classes.noWrap]: noWrap })}
    >
      {tags?.map(tag => (
        <Tag
          role={'listitem'}
          className={classNames?.tag}
          color={tag.color}
          key={tag.id}
          onClick={onTagClick ? () => onTagClick(tag) : undefined}
        >
          {tag.name}
        </Tag>
      ))}
      {children}
    </div>
  );
}